export const BANNER_MESSAGE_TAXONOMY_KEY = 'renewalstatus';
export const BANNER_BUTTON_TAXONOMY_KEY = 'renewalstatus';

export const API_TAG_PATTERN = /\{\{\s*([^}]+)\s*\}\}/g;
export const CSP_TAG_PATTERN = /\|\|\s*([^|]+)\s*\|\|/g;
export const CMS_TAG_PATTERN = /\[\[\s*([^\]]*)\s*\]\]/g;

export const TAG_PATTERNS = [API_TAG_PATTERN, CSP_TAG_PATTERN, CMS_TAG_PATTERN];

export const BREAK_POINT = 993;

export const ERRORS = {
  POLICY_NOT_VALID: 'Invalid policy number. Please try again later.',
  LOADING_ERROR: 'Something went wrong. Please try again later.',
  QAPI_NOT_AVAILABLE: 'Something went wrong. Please try again or call our customer service team.',
  SUBMIT_ERROR: 'We are having some issues submitting your request. Please try again later.'
};
